import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityEstadosRolLoadFailure,
  entityEstadosRolLoadSuccess,
  entityEstadosRolLoadRequest,
} from './entity-estados-rol.actions';
import { EntityEstadoRolService } from './entity-estado-rol.service';

@Injectable()
export class EntityEstadoRolEffect {
  // load
  loadRequestEntityRolEstado = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEstadosRolLoadRequest),
      mergeMap(() =>
        this.estadosRolService.getEstadosRol().pipe(
          map((items) => entityEstadosRolLoadSuccess({ items })),
          catchError((error) => of(entityEstadosRolLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private estadosRolService: EntityEstadoRolService,
  ) {
    this.estadosRolService.url = environment.apiUrl;
  }
}
